<template>
  <div class="contact">
    <ul>
      <!--
      <li>
        <router-link :to="{ name: 'Email', }">
          <img src="../assets/images/mail-icon.png" alt="Mail">
          <span class="text">E-Posta</span>
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </router-link>
      </li>
      -->
      <li class="wp-web">
        <a target="_blank" href="https://api.whatsapp.com/send?phone=908502224123">
          <i class="fa fa-whatsapp" style="font-size: 20px;" aria-hidden="true"></i>
          <span class="text">Whatsapp</span>
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </li>
      <!--
      <li>
        <router-link :to="{ name: 'Chat', query: { gim: '1' } }">
          <img src="../assets/images/chat-bubble-icon.png" alt="Mail">
          <span class="text">Capcanlı Destek</span>
          <span class="go-icon">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </span>
        </router-link>
      </li>
      -->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Contact',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul {
    list-style-type: none;
    width: 100%;
    padding: 0;

    li {
      width: 90%;
      margin: 0 auto;
      padding: 20px 0;
      border-bottom: 1px solid #E0E0E0;
      text-align: left;

      a {
        color: #858484;
        text-decoration: none;
        display: block;
      }

      img {
        float: left;
        max-width: 20px;
      }

      .text {
        margin-left: 20px;
      }

      .go-icon {
        float: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?57bc8497